module.exports = {
      id: "saudi-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#saudi",
      toString: function () {
        return this.url;
      }
    }